<template lang="pug">
#analisar-operacao
    div(v-show='mostrarFormulariosOperacao')
        BaseHeader(
            titulo='Analisar Operação',
            :voltarPara='true',
            :exibeBotao='false'
        )
            template(slot='direita')
                el-dropdown(trigger='click')
                    el-button.analisar-operacao__header__acao__botao(
                        type='primary'
                    )
                        i.el-icon-s-tools
                        span Ações
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='flow flow-environment',
                            @click.native='realizarAnaliseSocioambiental()'
                        ) Realizar análise socioambiental

        .view-container-base-header
            FormularioDadosGeraisOperacao(
                v-if='verificouSeEcadastroOuEdicao',
                ref='refFormularioDadosGerais',
                @dadosGerais='atualizarDadosGerais',
                :operacaoEditarOuClonar='operacaoEditar'
            )

            FormularioAtividadeOperacao(
                v-if='verificouSeEcadastroOuEdicao',
                @dadosAtividades='atualizarAtividades',
                :operacaoEditarOuClonar='operacaoEditar',
                :atividadeObrigatoria='atividadeObrigatoria'
            )

            FormularioPessoaOperacao(
                v-if='verificouSeEcadastroOuEdicao',
                @dadosPessoa='atualizarPessoa',
                :operacaoEditarOuClonar='operacaoEditar'
            )

            FormularioTerritorioGlebaOperacao(
                v-if='verificouSeEcadastroOuEdicao',
                @dadosTerritorioGleba='atualizarTerritorioGleba',
                :dadosEditarOuClonar='operacaoEditar',
                :dadosValidarSobreposicao='validarSobreposicao'
            )

            section.analisar-operacao__acao
                el-button.mr-2(size='small', @click='$router.go(-1)')
                    | Voltar

                el-button(
                    @click='realizarAnaliseSocioambiental()',
                    type='primary',
                    size='small'
                )
                    | Realizar Análise Socioambiental

    CardAnaliseSocioambientalOperacao(
        v-if='mostrarCardAnaliseSocioambiental',
        habilitar-analise,
        :habilitar-botao-cadastrar='false',
        :dadosDiagnostico='dadosAnaliseSocioambientalProtocolo',
        @aprovarOperacao='aprovarOperacao',
        @reprovarOperacao='reprovarOperacao',
        @cadastrarOperacao='salvarEdicaoOperacao',
        @fechar='fecharCardAnaliseSocioambientalOperacao'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import OperacaoService from '@/services/OperacaoService';
import FormularioTerritorioGlebaOperacao from '@/components/operacao/gestao/FormularioTerritorioGlebaOperacao.vue';
import CardAnaliseSocioambientalOperacao from '@/components/operacao/gestao/CardAnaliseSocioambientalOperacao.vue';
import FormularioDadosGeraisOperacao from '@/components/operacao/gestao/FormularioDadosGeraisOperacao.vue';
import FormularioAtividadeOperacao from '@/components/operacao/gestao/FormularioAtividadeOperacao.vue';
import FormularioPessoaOperacao from '@/components/operacao/gestao/FormularioPessoaOperacao.vue';

export default {
    name: 'AnalisarOperacao',

    components: {
        BaseHeader,
        CardAnaliseSocioambientalOperacao,
        FormularioDadosGeraisOperacao,
        FormularioAtividadeOperacao,
        FormularioPessoaOperacao,
        FormularioTerritorioGlebaOperacao
    },

    data() {
        return {
            operacaoEditar: null,
            validarSobreposicao: {
                idOperacao: null,
                idCategoria: null,
                datasPlantio: []
            },
            atividadeObrigatoria: true,
            dadosAnaliseSocioambientalProtocolo: {
                pessoas: [],
                territorios: [],
                glebas: []
            },
            operacao: {
                dadosGerais: null,
                atividades: [],
                pessoasGrupoEconomico: [],
                territoriosGlebas: []
            },
            verificouSeEcadastroOuEdicao: false,
            mostrarFormulariosOperacao: true,
            mostrarCardAnaliseSocioambiental: false
        };
    },

    async mounted() {
        await OperacaoService.buscarPorId(this.$route.params.id)
            .then(({ data }) => {
                this.operacaoEditar = data;
                this.validarStatusOperacao(data);
                this.verificouSeEcadastroOuEdicao = true;
            })
            .catch(error => {
                this.$notify.error({
                    message: error.message
                });
                this.$router.push({ name: 'operacao' });
            });

        this.validarSobreposicao.idOperacao = this.$route.params.id
            ? this.$route.params.id
            : null;
    },

    methods: {
        validarStatusOperacao(data) {
            if (
                data.analise.codigo !== 'AGUARDANDO_APROVACAO' &&
                data.analise.codigo !== 'EM_ANALISE'
            ) {
                throw new Error(
                    'Operação não pode ser analisada. Situação não está como: Aguardando Aprovação ou Em Análise.'
                );
            }
        },

        atualizarDadosGerais(dadosGerais) {
            this.operacao.dadosGerais = dadosGerais;
            if (this.operacao.dadosGerais.categoria) {
                this.atividadeObrigatoria =
                    this.operacao.dadosGerais.categoria.atividadeObrigatoria;
            }
            this.validarSobreposicao.idCategoria = dadosGerais.categoria.id;
        },

        atualizarPessoa(dadosPessoas) {
            this.operacao.pessoasGrupoEconomico = dadosPessoas;
        },

        atualizarAtividades(dadosAtividades) {
            this.operacao.atividades = dadosAtividades;
            this.validarSobreposicao.datasPlantio = [];
            this.operacao.atividades.forEach(atividade => {
                if (atividade.inicioPlantio) {
                    this.validarSobreposicao.datasPlantio.push(
                        atividade.inicioPlantio
                    );
                }
            });
        },

        atualizarTerritorioGleba(territoriosGlebas) {
            this.operacao.territoriosGlebas = territoriosGlebas;
        },

        async aprovarOperacao(payload) {
            const idOperacaoGerada = await this.salvarEdicaoOperacao();
            await OperacaoService.aprovar(idOperacaoGerada, payload)
                .then(() => {
                    this.$notify.success({
                        message: 'Operação aprovada com sucesso!'
                    });
                    this.$router.push({ name: 'operacao' });
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Não foi possível aprovar a operação. Favor verificar os dados inseridos e tentar novamente. Lembre-se de verificar os campos em que foram inseridos dados copiados de outras fontes. Se o problema persistir, favor entrar em contato com os administradores da plataforma.',
                        duration: 15000
                    });
                    this.$router.push({ name: 'operacao' });
                })
                .finally(() => {
                    this.mostrarCardAnaliseSocioambiental = false;
                });
        },

        async reprovarOperacao(payload) {
            const idOperacaoGerada = await this.salvarEdicaoOperacao();
            await OperacaoService.reprovar(idOperacaoGerada, payload)
                .then(() => {
                    this.$notify.success({
                        message: 'Operação reprovada com sucesso!'
                    });
                    this.$router.push({ name: 'operacao' });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Não foi possível reprovar a operação.'
                    });
                })
                .finally(() => {
                    this.mostrarCardAnaliseSocioambiental = false;
                });
        },

        async realizarAnaliseSocioambiental() {
            if (!(await this.validarFormularios())) return;

            this.dadosAnaliseSocioambientalProtocolo = {
                pessoas: [],
                territorios: []
            };

            const setPessoa = new Set();

            const pessoasUnicas = this.operacao.pessoasGrupoEconomico.filter(
                pessoa => {
                    const duplicada = setPessoa.has(pessoa.cpfCnpj);
                    setPessoa.add(pessoa.cpfCnpj);
                    return !duplicada;
                }
            );

            pessoasUnicas
                .map(e => ({
                    cpfCnpj: e.cpfCnpj,
                    nomeRazaoSocial: e.nomeRazaoSocial
                }))
                .forEach(e => {
                    this.dadosAnaliseSocioambientalProtocolo.pessoas.push(e);
                });

            this.operacao.territoriosGlebas.forEach(territorio => {
                const glebas = territorio.glebas.map(gleba => {
                    return {
                        utilizouAreaTotalTerritorio:
                            territorio.utilizouAreaTotalTerritorio,
                        geometria: gleba.geometria,
                        nome: gleba.nome
                    };
                });

                this.dadosAnaliseSocioambientalProtocolo.territorios.push({
                    idTerritorio: territorio.idTerritorio,
                    glebas
                });
            });

            this.mostrarFormulariosOperacao = false;
            this.mostrarCardAnaliseSocioambiental = true;
        },

        fecharCardAnaliseSocioambientalOperacao() {
            this.mostrarFormulariosOperacao = true;
            this.mostrarCardAnaliseSocioambiental = false;
        },

        async salvarEdicaoOperacao() {
            if (!(await this.validarFormularios())) return;

            if (this.operacao.dadosGerais.valorTotalOperacao === 0) {
                this.operacao.dadosGerais.valorTotalOperacao = null;
            }

            return OperacaoService.editar(
                this.operacao,
                this.operacaoEditar.dadosGerais.id
            )
                .then(({ data }) => data.idOperacaoGerada)
                .catch(error =>
                    this.$notify.error({
                        message: error.response.data
                    })
                );
        },

        async validarFormularios() {
            if (
                !(await this.$refs.refFormularioDadosGerais.validarFormulario())
            ) {
                this.$notify.warning({
                    message:
                        'Preencha informações obrigatórias dos dados gerais.'
                });
                return false;
            }

            if (
                this.operacao.atividades.length === 0 &&
                this.operacao.dadosGerais.categoria.id < 4
            ) {
                this.$notify.warning({
                    message: 'Preencha informações obrigatórias de atividades.'
                });
                return false;
            }

            if (this.operacao.pessoasGrupoEconomico.length === 0) {
                this.$notify.warning({
                    message:
                        'Preencha informações obrigatórias de pessoas / grupo econômico.'
                });
                return false;
            }

            if (this.operacao.territoriosGlebas.length === 0) {
                this.$notify.warning({
                    message:
                        'É obrigatório cadastrar pelo menos uma gleba em cada um dos territórios adicionados.'
                });
                return false;
            }

            return true;
        }
    }
};
</script>

<style lang="scss">
#analisar-operacao {
    .analisar-operacao__header__acao__botao {
        font-size: 14px;
        color: var(--white);
        background: var(--primary);
        border-color: var(--primary);
        border-radius: $default-border-radius;
        font-weight: map-get($font-weight, normal);
        padding: 12px 20px;
    }
    .analisar-operacao__header {
        margin: 0;
        align-items: center;
        padding: 20px;
        height: 100px;
        width: 100%;
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .analisar-operacao__header__title {
            padding: 0;
            color: var(--primary-font-color);
            font-weight: map_get($font-weight, medium);
            font-size: map-get($font-size, x-large);

            .analisar-operacao__header__title--acao {
                cursor: pointer;
                margin-right: 10px;
                font-size: 22px;
            }
        }
    }

    .analisar-operacao__acao {
        display: flex;
        justify-content: space-between;
    }
}
</style>
